import { defineMessages } from 'react-intl';

export default defineMessages({
    cpDetailsOptionPlaceholder: {
        id: 'twia.fnol.cp.views.details.Option',
        defaultMessage: '-- Option --',
    },
    cpDetailsClassCodePlaceholder: {
        id: 'twia.fnol.cp.views.details.Select Class Code',
        defaultMessage: '-- Select Class Code --',
    },
    cpDetailsRoofCoveringPlaceholder: {
        id: 'twia.fnol.cp.views.details.Select Roof Covering Materials',
        defaultMessage: '-- Select Roof Covering Materials --',
    },
    cpDetailsExteriorWallPlaceholder: {
        id: 'twia.fnol.cp.views.details.Select Exterior Wall Material',
        defaultMessage: '-- Select Exterior Wall Material --',
    },
    cpDetailsOccupancyPlaceholder: {
        id: 'twia.fnol.cp.views.details.Select Type of Occupancy',
        defaultMessage: '-- Select Type of Occupancy --',
    },
    cpDetailsLossAreaPlaceholder: {
        id: 'twia.fnol.cp.views.details.Select Loss Area',
        defaultMessage: '-- Select Loss Area --',
    },
});
